function clickEffect(e){
  var d=document.createElement('div');
  d.className='clicker';
  d.style.top=e.clientY+"px";d.style.left=e.clientX+"px";
  for (i=0; i<8; i++) {
    d.appendChild(document.createElement('span'));
  }
  document.body.appendChild(d);
  d.addEventListener('animationend',function(){d.parentElement.removeChild(d);}.bind(this));
}
const siteByBrighter = document.querySelector('.site-by-brighter');
if (siteByBrighter) {
  siteByBrighter.addEventListener('click', clickEffect);
}
